import PropTypes from "prop-types";
import { Link as RouteLink } from "react-router-dom";
import styled from "styled-components";
import excludeStyleProps from "src/utils/exclude-style-props";

const Link = styled(RouteLink).withConfig({
    shouldForwardProp: excludeStyleProps(["variant"]),
})`
    border-bottom: ${({ theme, variant }) =>
        variant === "plain" ? null : `0px solid ${theme.palette.primary.main}`};
    color: ${({ theme, variant }) =>
        variant === "plain" ? theme.palette.secondary.main : theme.palette.primary.main};
    text-decoration: none;

    &:hover {
        border-bottom: ${({ theme, variant }) =>
            variant === "plain" ? null : `2px solid ${theme.palette.primary.main}`};
    }
`;

Link.propTypes = {
    variant: PropTypes.oneOf(["default", "plain"]),
};

Link.defaultProps = {
    variant: "default",
};

export default Link;
